import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { Assessment } from "@/core/types";
import { MEDIUM_LIVED_CACHE } from "@/lib/constants/cache";

import { assessmentKeys } from "../keyFactory";
import { getDefinition } from "../queryFunctions/getDefinition";

type UseAssessmentDefinitionProps<TData = Assessment> = {
  id: string;
  select?: (data: Assessment) => TData;
};

type AssessmentDefinitionQueryOptions = UseQueryOptions<
  Assessment,
  unknown,
  Assessment,
  ReturnType<typeof assessmentKeys.detail>
>;

export function useAssessmentDefinition<TData = Assessment>({
  id,
  select,
}: UseAssessmentDefinitionProps<TData>) {
  return useQuery({ ...optionFactory(id), select });
}

function optionFactory(id: string) {
  return {
    queryFn: () => getDefinition({ id }),
    queryKey: assessmentKeys.detail(id),
    staleTime: MEDIUM_LIVED_CACHE,
  } satisfies AssessmentDefinitionQueryOptions;
}
